import styled from "styled-components";
import { Row, Col, Card } from "antd";

export const StyledHeaderImage = styled.img`
  width: 100%;
  object-fit: cover;
  height: 270px;
  top: 0;
  left: 0;
`;

export const StyledCard = styled(Card)`
  position: absolute;
  background-color: var(--neutral);
  top: 80%;
  .ant-card-body {
    padding: 1em;
  }
`;

export const StyledRow = styled(Row)``;

export const StyledCol = styled(Col)`
  padding-top: 0.7em;
  padding-bottom: 0.7em;
  line-height: 100%;
  border-left: 1px solid rgba(10, 40, 63, 0.25);
  align-content: center;
`;

export const TotalStyledDiv = styled.div`
  position: relative;
  height: 270px;
`;
